/**
 * Object to store a selected unit format for an unit
 */
export interface IUserProfileUnit {
    /** Unique unit identifier */
    unitIdentifier: string;
    /** Index of selected unit format from values */
    selectedValue: number;
}

export class UserProfileUnit implements IUserProfileUnit {
    public unitIdentifier: string;
    public selectedValue: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IUserProfileUnit);
    constructor(obj?: any) {
        this.unitIdentifier = obj && obj.unitIdentifier || '';
        this.selectedValue = obj && obj.selectedValue || 0;
    }
}
